<template>
  <v-card
    flat
    class="pa-5 pt-0 bg-pwt_snow"
    v-if="unreadNotificationCount > 0 || pastNotifications.length > 0"
  >
    <!-- profile section -->
    <ProfileCard />
    <!--  unread notifications bar -->
    <div id="unread_notifications_bar">
      <v-icon color="#2eaeff" class="mr-2"> mdi-bell-badge-outline </v-icon>
      <span>
        {{ unreadNotificationCount }} unread notification{{
          unreadNotificationCount !== 1 ? "s" : ""
        }}
      </span>
    </div>
    <!-- notifications section -->
    <v-card-title class="text-h5"> Notifications </v-card-title>
    <!-- search bar -->
    <v-card-text>
      <v-text-field
        v-model="search"
        label="Search all notifications..."
        single-line
        hide-details
        bg-color="transparent"
      >
      </v-text-field>
    </v-card-text>
    <v-card-title class="text-h6"> Unread notifications </v-card-title>
    <v-card-text>
      <v-list v-if="unreadNotifications.length > 0" class="mb-5">
        <NotificationsListItem
          v-for="notification in unreadNotifications"
          :key="notification.id"
          :notification="notification"
        />
      </v-list>

      <div v-else class="text-subtitle-1 mb-5">No unread notifications</div>
    </v-card-text>
    <v-card-title class="text-h6"> Past notifications </v-card-title>
    <v-card-text>
      <v-list v-if="pastNotifications.length > 0" class="mb-5">
        <NotificationsListItem
          v-for="notification in pastNotifications"
          :key="notification.id"
          :notification="notification"
        />
      </v-list>

      <div v-else class="text-subtitle-1 mb-5">No past notifications</div>
    </v-card-text>
  </v-card>
  <!-- full empty state -->
  <v-card v-else flat class="pa-5 pt-0 bg-pwt_snow">
    <!-- profile section -->
    <ProfileCard />
    <v-card-title class="text-center"> Nothing here yet </v-card-title>
    <v-card-text class="text-center">
      You don’t have any activity yet. Start planning trips or managing your
      account to see your notifications and activity
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import ProfileCard from "@/components/user/profile/ProfileCard.vue";
import { useNotificationsStore } from "@/domains/notifications/notificationsStore.ts";
import { computed, ref } from "vue";
import NotificationsListItem from "./NotificationsListItem.vue";

const notificationsStore = useNotificationsStore();
const unreadNotificationCount = computed(
  () => notificationsStore.unreadNotificationCount,
);
const unreadNotifications = computed(
  () => notificationsStore.getAllUnreadNotifications,
);
const pastNotifications = computed(
  () => notificationsStore.getAllReadNotifications,
);

const search = ref("");
</script>
<style scoped>
#unread_notifications_bar {
  background-color: #eaf7ff;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  height: 70px;
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>
